import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { CMSPortalService } from '../shared/service/cms-portal.service';
import { Video } from '../shared/model/video.model';
import { ActivatedRoute } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-videos-detalhe',
  templateUrl: './video-detalhe.component.html',
  styleUrls: ['./video-detalhe.component.css']
})
export class VideosDetalheComponent implements OnInit {

  public video: Video;
  safeURL: any;

  constructor(private service: CMSPortalService,
              private route: ActivatedRoute,
              private _sanitizer: DomSanitizer) { }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
        if (params['id']) {
          this.carregarVideo(params['id']);
        } else {
          this.carregarUltimoVideo();
        }
    });
  }

  carregarVideo(id: string) {
    this.service.getVideo(id).subscribe(res => {
      this.video = res.conteudo[0];
      if (this.video.tipo === 'Y') {
        this.safeURL = this._sanitizer
            .bypassSecurityTrustResourceUrl('https://www.youtube.com/embed/' + this.recuperaIdYoutube(this.video.url));
      } else if (this.video.tipo === 'U') {
        this.safeURL = this._sanitizer
            .bypassSecurityTrustResourceUrl(this.video.video.replace('data:.', 'data:video/'));
      } else {
        this.safeURL = this._sanitizer.bypassSecurityTrustResourceUrl(this.video.url);
      }
    });
  }

  carregarUltimoVideo() {
    this.service.getVideos().subscribe(res => {
      this.video = res.conteudo[0];
      if (this.video.tipo === 'Y') {
        this.safeURL = this._sanitizer
            .bypassSecurityTrustResourceUrl('https://www.youtube.com/embed/' + this.recuperaIdYoutube(this.video.url));
      } else if (this.video.tipo === 'U') {
        this.safeURL = this._sanitizer
            .bypassSecurityTrustResourceUrl(this.video.video.replace('data:.', 'data:video/'));
      } else {
        this.safeURL = this._sanitizer.bypassSecurityTrustResourceUrl(this.video.url);
      }
    });
  }

  recuperaIdYoutube(url: string): string {
    const regExp = /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
    const match = url.match(regExp);
    if (match && match[2].length === 11) {
      return `${match[2]}`;
    } else {
      return '';
    }
  }

}
